var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3998 7.86744L9.92227 6.38995L7.51477 3.98245C7.00477 3.47995 6.13477 3.83995 6.13477 4.55995V9.23245V13.4399C6.13477 14.1599 7.00477 14.5199 7.51477 14.0099L11.3998 10.1249C12.0223 9.50994 12.0223 8.48994 11.3998 7.86744Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightPagination);
export default __webpack_public_path__ + "static/media/arrow-right-pagination.45326dc324cdd5d971b1d039f03005c1.svg";
export { ForwardRef as ReactComponent };